import { Subscription } from 'rxjs';

export interface ReportOption {
  title: string;
  subtitle: string;
  checked?: boolean;
}

export type ReportFeature = 'upload-products-list' | 'lookup-products';

export type ReportFeatureType = 'PRODUCT_COLLECTION' | 'PRODUCT_DETAILS_V2' | 'HISTORICAL_DATA';

export interface FeatureReportItemsStatus {
  itemsProcessed: number;
  status: ReportStatusType;
  progressPercent: number;
}

export interface ReportItem {
  reportId: string;
  reportName: string;
  status: ReportStatusType;
  itemsCount: number;
  maxItems: number;
  createdAt: Date;
  productsCollectionRequest: { [key: string]: string[] | string | number };
  downloading?: boolean;
  generating?: boolean;
  downloadSubscription?: Subscription;
  reportStatus: Record<ReportFeatureType, FeatureReportItemsStatus | null>
}

export type ReportStatusType = 'STARTED' | 'QUEUED' | 'COUNT_ONLY' | 'READY_FOR_REPORT' | 'GENERATING_REPORT' | 'REPORTING_FAILED' | 'PARTIAL_SUCCESS' | 'REPORT_CREATION_FAILED' | 'SUCCESS';

export const ReportStatusLabels: Record<ReportStatusType, string> = {
  STARTED: 'In Progress...',
  QUEUED: 'In Queue',
  COUNT_ONLY: 'Counting',
  READY_FOR_REPORT: 'Almost done',
  GENERATING_REPORT: 'Generating Report...',
  REPORTING_FAILED: 'Report Failed',
  PARTIAL_SUCCESS: 'Partially Complete',
  REPORT_CREATION_FAILED: 'Report Failed',
  SUCCESS: 'Completed',
};

